const permissions = {
  listJobsBacklog: 'JB002',
  addJobBacklog: 'JB015',
  editJobBacklog: 'JB016',
  removeJobBacklog: 'JB017',
  jobs: 'JB001',
  jobsBoard: 'JB003',
  jobsMonitor: 'JB020',
  jobsReport: 'JB004',
  jobsImport: 'JB013',
  jobsWorkingActivity: 'JB014',
  listAsignedJobsBacklog: 'GF006',
  asignJobBacklogToUnit: 'GF007',
  listOwnLocations: 'JB008',
  addLocations: 'JB005',
  editLocations: 'JB006',
  assignLocations: 'JB007',
  listLocationImages: 'JB010',
  addLocationImages: 'JB011',
  removeLocationImages: 'JB012',
  bulkUserManagement: 'JB018',
  checkInOutWeb: 'JB022',
  jobPreferences: 'JB021'
};

export default permissions;
